import { render, staticRenderFns } from "./Typology.vue?vue&type=template&id=138202c6"
import script from "./Typology.vue?vue&type=script&lang=ts"
export * from "./Typology.vue?vue&type=script&lang=ts"
import style0 from "./Typology.vue?vue&type=style&index=0&id=138202c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports